var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"content-devx padding-half"},[_c('div',{staticClass:"vademecum-product-warning"},[_vm._t("default",function(){return [_vm._v("\n        default warning text\n      ")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }